import script from "./ProductEditRightPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductEditRightPanel.vue?vue&type=script&setup=true&lang=js"

import "./ProductEditRightPanel.vue?vue&type=style&index=0&id=2804223f&lang=scss"

const __exports__ = script;

export default __exports__